import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import profilePic from "../../Assets/ashwini_photo.jpeg"; 
import "./Home.css"; // 👈 Add this CSS file if not already

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            {/* Left: Text */}
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi, great to see you !{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                 🖱️🌟
                </span>
              </h1>
              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Ashwini Kumar Nayak </strong>
              </h1>
              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            {/* Right: Circular Profile */}
            <Col md={5} className="d-flex justify-content-center align-items-center">
              <div className="profile-pic-container">
                <img src={profilePic} alt="Profile" className="profile-pic" />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
